import apiFetch from "@/app/auth/apiFetch";
import type { NavigateFunction } from "react-router-dom";

const API_URL = import.meta.env.VITE_API_URL;

export interface CampaignListItem {
  id: number;
  name: string;
  status?: string | null;
  subscription_id?: number | null;
  created_at?: string | null;
  politeness?: string | null;
  period?: string | null;
  title?: string | null;
  candidate_count?: number;
}

export interface PaginatedCampaignsResponse {
  items: CampaignListItem[];
  total: number;
  page: number;
  size: number;
  pages: number;
}

export async function listCampaigns(
  navigate: NavigateFunction,
  params?: { page?: number; size?: number; status?: string }
) {
  const q = new URLSearchParams();
  q.set("page", String(params?.page ?? 1));
  q.set("size", String(params?.size ?? 50));
  if (params?.status) q.set("status", params.status);
  const url = `${API_URL}/campaigns?${q.toString()}`;
  const res = await apiFetch(url, { method: "GET" }, navigate);
  if (!res?.ok) throw new Error("Erreur lors du chargement des campagnes");
  return res.json() as Promise<PaginatedCampaignsResponse>;
}
